<template>
  <section>
    <download-popup v-if="downloadLayout" :close="closeDownloadLayout" :contenttype="downloadContentType" :contentid="downloadContentId" :content-info="contentInfo"/>
    <div :class="editorModeClass" v-if="!isLoading && dataList.length > 0">
      <div class="wrap">
        <div class="my-purchase-edit-wrap">
          <div v-if="isDownload && !isEditMode" class="my-download-count">다운로드 가능 횟수&lpar;<span>{{downloadAvailableCount}}</span>&sol;{{downloadCount}}&rpar;
          </div>

          <button v-if="!isEditMode" class="my-purchase-edit" @click="editMode">
            <span>편집</span>
          </button>
        </div>

        <div class="my-purchase-edit-wrap" v-if="isEditMode">
          <ul class="my-purchase-edit-l">
            <li><button :class="selectedClass" @click="selectedDelete">선택삭제({{checkCount}})</button></li>
            <li><button class="all-delete" @click="allDelete">{{ totalDeleteText }}</button></li>
          </ul>

          <ul class="my-purchase-edit-r">
            <li><button @click="editMode">나가기</button></li>
          </ul>
        </div>
        <div v-if="viewMode === 'vod'">
          <ul class="my-history-wrap">
            <template v-for="(vod, index) in dataList">
              <li v-if="index % 2 === 0" :key="index">
                <break-list-vod :data="dataList[index]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index" :set-check-fn="setCheck"></break-list-vod>
                <break-list-vod :data="dataList[index+1]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index+1" :set-check-fn="setCheck"></break-list-vod>
              </li>
            </template>
          </ul>
        </div>
        <ul class="my-movie-list" v-if="viewMode === 'movie'">
          <break-list-movie v-for="(movie, index) in dataList" :editor-mode="isEditMode" :data="movie" :view-mode="viewMode" :index="index" :key="index" :set-check-fn="setCheck"></break-list-movie>
        </ul>
        <div v-if="viewMode==='download'">
          <ul class="my-download-list-wrap">
            <template  v-for="(download, index) in dataList">
              <li v-if="index % 2 === 0" :key="dataList.length + '_' + index">
                <break-list-download :data="dataList[index]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index" :set-check-fn="setCheck" :set-download-event-fn="setDownloadEvent"></break-list-download>
                <break-list-download :data="dataList[index+1]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index+1" :set-check-fn="setCheck" :set-download-event-fn="setDownloadEvent"></break-list-download>
              </li>
            </template>
          </ul>
        </div>
        <template v-if="viewMode === 'singular'">
          <template v-for="(singular, index) in dataList">
            <div class="my-purchase-row" v-if="index % 2 === 0" :key="index">
              <break-list-single-purchase :data="dataList[index]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index" :set-check-fn="setCheck"></break-list-single-purchase>
              <break-list-single-purchase :data="dataList[index+1]" :editor-mode="isEditMode" :view-mode="viewMode" :index="index+1" :set-check-fn="setCheck"></break-list-single-purchase>
            </div>
          </template>
        </template>
        <p v-if="viewMode === 'vod' || viewMode === 'movie'" class="my-history-noti">
          <span>동일한 콘텐츠를 여러 번 시청한 경우, 마지막 이력만 표시됩니다.</span>
        </p>

        <paging-component :current-page="currentPage" :page-count="totalCount" :limit="limit" :paging-count="pagingCnt" wrapper-class="paging-type02" />
      </div>
    </div>

    <div class="my-history-body" v-else-if="!isLoading">
      <div class="wrap">
        <empty-list :text="emptyText"></empty-list>
      </div>
    </div>

  </section>
</template>

<script>
import PagingComponent from '@/components/common/PagingComponent'
import DownloadPopup from '@/components/player/PopupDownload'
import { deleteDownloads, deleteMypurchaseContentsItem, getDownloads, getMypurchaseContentsItem,
  getMyviewContents, deleteMyviewContents, deleteMyviewAllContents, deleteMyviewAllDownload, deleteAllPurchaseVoucher } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import { setDisableScrolling, scrollTop } from '@/common/utils/common'
import _ from 'lodash'
import BreakListVod from '@/components/mypooq/breaklist/BreakListVod'
import BreakListMovie from '@/components/mypooq/breaklist/BreakListMovie'
import BreakListDownload from '@/components/mypooq/breaklist/BreakListDownload'
import BreakListSinglePurchase from '@/components/mypooq/breaklist/BreakListSinglePurchase'
import EmptyList from '@/components/mypooq/EmptyList'
import { showVoucherPopupWithContext } from '@/common/utils/scalable.player'
export default {
  components: {
    PagingComponent,
    DownloadPopup,
    BreakListVod,
    BreakListMovie,
    BreakListDownload,
    BreakListSinglePurchase,
    EmptyList
  },
  data () {
    return {
      dataList: [],
      checklist: [],
      checkCount: 0,
      isEditMode: false,
      currentPage: 1,
      pagingCnt: 10,
      limit: 10,
      totalCount: 0,
      downloadLayout: false, // 다운로드 레이어 팝업 show/hide
      downloadContentId: '', // 다운로드 팝업에서 사용하는 컨텐츠 ID
      downloadContentType: '', // 다운로드 팝업에서 사용하는 컨텐츠 타입
      downloadCount: 0,
      downloadAvailableCount: 0,
      isLoading: true,
      settings: cookie.getAdultSettings(),
      contentInfo: null
    }
  },
  props: {
    viewMode: {
      type: String
    }
  },
  methods: {
    setCheck (id) {
      let propertyName = ''
      if (this.viewMode === 'movie') {
        propertyName = 'movieid'
      } else if (this.viewMode === 'singular') {
        propertyName = 'paymentid'
      } else {
        propertyName = 'contentid'
      }

      this.datalist = this.dataList.map((content) => {
        if (_.get(content, propertyName, '') === id) {
          return _.set(content, 'checked', !_.get(content, 'checked', false))
        } else {
          return content
        }
      })
      this.checklist = this.dataList.filter((content) => content.checked)
      this.checkCount = this.checklist.length
    },
    editMode () {
      this.allCount()
      if (this.isEditMode) {
        this.$nextTick(() => this.checkedReset())
      }
      this.$nextTick(() => {
        this.isEditMode = !this.isEditMode
        this.checklist = []
        this.checkCount = 0
      })
    },
    allCount () {
      const vodMovieMode = this.viewMode !== 'download' && this.viewMode !== 'singular'
      const getData = response => response.data
      const setTotalCount = data => { this.totalCount = Number(_.get(data, vodMovieMode ? ['0', 'pagecount'] : 'pagecount', '1')); return data }
      if (this.viewMode === 'download') {
        getDownloads({ contenttype: 'all', offset: 0, limit: this.limit, orderby: 'new' }).then(getData).then(setTotalCount)
      } else if (this.viewMode === 'singular') {
        getMypurchaseContentsItem({ offset: 0, limit: this.limit }).then(getData).then(setTotalCount)
      } else {
        getMyviewContents({ contenttype: this.viewMode, offset: 0, limit: this.limit, orderby: 'new' }).then(getData).then(setTotalCount)
      }
    },
    selectedDelete () {
      const getData = response => response.data
      const ifSuccessThenReset = data => {
        if (_.get(data, 'resultmessage', '') === 'success' || _.get(data, 'resultcode', '') === '200') {
          this.reset()
        }
        return data
      }
      const getAllCount = (data) => {
        if (this.viewMode === 'singular') {
          setTimeout(() => {
            this.allCount()
          }, 1000)
        } else {
          this.allCount()
        }
        return data
      }
      // const getAllCount = () => this.allCount()
      let checkedInfoArr = []
      const chcekedInfoParamInfo = (checkList) => {
        checkList.forEach((checkItem) => {
          if (this.viewMode === 'download') {
            checkedInfoArr.push(checkItem.contentid)
          } else if (this.viewMode === 'singular') {
            checkedInfoArr.push(checkItem.paymentid)
          } else {
            let contentid = this.viewMode === 'movie' ? checkItem.movieid : checkItem.contentid
            let programid = this.viewMode === 'movie' ? 'MOVIE' : checkItem.programid
            checkedInfoArr.push({
              contentid: contentid,
              programid: programid
            })
          }
        })
        return checkedInfoArr
      }
      if (this.checklist.length === 0) return
      if (this.viewMode === 'download') {
        deleteDownloads({ id: chcekedInfoParamInfo(this.checklist) }).then(getData).then(ifSuccessThenReset)
      } else if (this.viewMode === 'singular') {
        deleteMypurchaseContentsItem({ paymentId: chcekedInfoParamInfo(this.checklist) }).then(getData).then(ifSuccessThenReset).then(getAllCount)
      } else {
        deleteMyviewContents({ contenttype: this.viewMode, contentinfo: chcekedInfoParamInfo(this.checklist) })
          .then(getData).then(ifSuccessThenReset).then(getAllCount)
      }
    },
    reset () {
      this.isLoading = true
      this.dataList = []
      this.checklist = []
      this.totalCount = 0
      this.checkCount = 0
      if (this.viewMode === 'singular') {
        setTimeout(() => {
          this.setData()
        }, 1000)
      } else {
        this.setData()
      }
    },
    allDelete () {
      const confirmMsg = this.viewMode === 'vod' || this.viewMode === 'movie'
      ? '전체삭제를 진행하시겠습니까? 내역이 모두 삭제됩니다.' : '전체삭제를 진행하시겠습니까?' + this.totalCount + '건의 내역이 모두 삭제됩니다.'
      if (confirm(confirmMsg)) {
        if (this.viewMode === 'vod' || this.viewMode === 'movie') {
          deleteMyviewAllContents({ contenttype: this.viewMode, contentinfo: 'y' }).then(() => {
            this.reset()
          })
        } else if (this.viewMode === 'download') {
          deleteMyviewAllDownload({ contenttype: 'all' }).then(() => {
            this.reset()
          })
        } else if (this.viewMode === 'singular') {
          deleteAllPurchaseVoucher().then(() => {
            this.reset()
          })
        }
      }
    },
    setDownloadEvent () {
      let self = this
      window.showDownloadLayout = function (contentInfo, contentType) {
        if (cookie.getCredential() === 'none') {
          window.showLoginLayout()
          return
        }
        self.contentInfo = contentInfo
        self.downloadContentId = contentType === 'movie' ? contentInfo.movieid : contentInfo.contentid
        self.downloadContentType = contentType
        self.downloadLayout = true
        window.showVoucherPopup = showVoucherPopupWithContext({ type: self.downloadContentType, contentInfo: contentInfo }) // 이용권 팝업
        setDisableScrolling(true) // 윈도우 스크롤 방지
      }
    },
    // 다운로드 레이어 팝업 닫기
    closeDownloadLayout () {
      this.downloadLayout = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    setData () {
      scrollTop()
      this.isLoading = true
      this.limit = this.viewMode === 'movie' ? 30 : this.viewMode === 'singular' ? 10 : 12
      const offset = this.limit * (this.currentPage - 1)
      const vodMovieMode = this.viewMode !== 'download' && this.viewMode !== 'singular'
      const getData = response => response.data
      const setDataList = data => { this.dataList = _.get(data, vodMovieMode ? ['0', 'list'] : 'list', []).map((item) => _.set(item, 'checked', false)); return data }
      const setDownloadCount = data => { this.downloadCount = _.get(data, 'totalcount.downloadcontentcount', 0); return data }
      const setAvailableCount = data => { this.downloadAvailableCount = _.get(data, 'totalcount.downloadavailablecount', 0); return data }
      const setTotalCount = data => { this.totalCount = Number(_.get(data, vodMovieMode ? ['0', 'pagecount'] : 'pagecount', '1')); return data }
      const currentPageMove = () => {
        if (this.dataList.length === 0 && offset !== 0 && this.currentPage !== 1) {
          this.$router.push({
            name: this.$route.name,
            query: {
              page: this.currentPage - 1
            }
          })
        }
      }
      const loadComplete = () => { this.isLoading = false }
      if (this.viewMode === 'download') {
        getDownloads({ contenttype: 'all', offset, limit: this.limit, orderby: 'new' })
          .then(getData)
          .then(setDataList)
          .then(setDownloadCount)
          .then(setAvailableCount)
          .then(setTotalCount)
          .then(currentPageMove)
          .then(loadComplete)
        this.setDownloadEvent()
      } else if (this.viewMode === 'singular') {
        getMypurchaseContentsItem({ offset, limit: this.limit })
          .then(getData).then(setDataList).then(setTotalCount).then(currentPageMove).then(loadComplete)
      } else {
        getMyviewContents({ contenttype: this.viewMode, offset, limit: this.limit, orderby: 'new' })
          .then(getData).then(setDataList).then(setTotalCount).then(currentPageMove).then(loadComplete)
      }
    },
    checkedReset () {
      this.dataList = this.dataList.map((content) => {
        return _.set(content, 'checked', false)
      })
    }
  },
  computed: {
    emptyText () {
      if (this.viewMode === 'vod') {
        return 'VOD 시청내역이 없어요.'
      } else if (this.viewMode === 'movie') {
        return '영화 시청내역이 없어요.'
      } else if (this.viewMode === 'download') {
        return '다운로드 내역이 없어요.'
      } else {
        return '개별 구매 내역이 없어요.'
      }
    },
    selectedClass () {
      return this.checkCount > 0 ? 'selected-delete' : 'not-selecte'
    },
    editorModeClass () {
      return this.isEditMode ? 'my-history-body editor-mode' : 'my-history-body'
    },
    isDownload () {
      return _.get(this.$route, 'name', '') === 'use_list_download'
    },
    totalDeleteText () {
      return this.viewMode === 'vod' || this.viewMode === 'movie' ? '전체삭제' : `전체삭제(${this.totalCount})`
    }
  },
  created () {
    this.currentPage = +_.get(this.$route, ['query', 'page'], '1')
    this.setData()
  }
}
</script>
